import React, {FunctionComponent} from 'react'
import styles from './TaskFilters.module.sass'
import {Brand, ClientWithBrands, DirectionWithDepartments, TaskType} from '../../../../../responses/refs/refs'
import {useRootDispatch, useRootSelector} from '../../../../../utils/hooks'
import {User} from '../../../../../responses/users'
import {userActions} from '../../../../../redux/global/user/user-actions'
import SwitchSort from '../../../../controls/SwitchSort/SwitchSort'
import RequestDropdown from '../../../../data-components/dropdowns/RequestDropdown/RequestDropdown'
import {apiRequests} from '../../../../../http/config'
import {Departments} from '../../../../../responses/departments'
import {flow} from 'fp-ts/function'
import TwoLevelDropdown from '../../../../data-components/dropdowns/TwoLevelDropdown/TwoLevelDropdown'
// import ThreeLevelDropdown from '../../../../data-components/dropdowns/ThreeLevelDropdown/ThreeLevelDropdown'
import {WorkObject} from '../../../../../responses/objects'
import {taskFiltersActions} from '../../../../../redux/pages/task-list/TaskFilters'
import FiltersClearIcon from '../../../../../../files/filters-clear.svg'
import Button from '../../../../controls/Button/Button'
import clsx from 'clsx'
import Spacer from '../../../../etc/Spacer'

function addDirectionLS(e: any) {// eslint-disable-line
    window.localStorage.setItem('TF_direction', JSON.stringify(e.payload))
}

function addDepartmentLS(e: any) {// eslint-disable-line
    window.localStorage.setItem('TF_department', JSON.stringify(e.payload))
}

function addUserLS(e: any) {// eslint-disable-line
    window.localStorage.setItem('TF_user', JSON.stringify(e.payload))
}

function addClientLS(e: any) {// eslint-disable-line
    window.localStorage.setItem('TF_client', JSON.stringify(e.payload))
}

function addBrandLS(e: any) {// eslint-disable-line
    window.localStorage.setItem('TF_brand', JSON.stringify(e.payload))
}

function addWorkObjectLS(e: any) {// eslint-disable-line
    window.localStorage.setItem('TF_work_object', JSON.stringify(e.payload))
}

function addTasksTypeLS(e: any) {// eslint-disable-line
    window.localStorage.setItem('TF_tasks_type', JSON.stringify(e.payload))
}

function clearFilterLS() {
    window.localStorage.removeItem('TF_direction')
    window.localStorage.removeItem('TF_department')
    window.localStorage.removeItem('TF_user')
    window.localStorage.removeItem('TF_client')
    window.localStorage.removeItem('TF_brand')
    window.localStorage.removeItem('TF_work_object')
    window.localStorage.removeItem('TF_tasks_type')
}

const TaskFiltersDesktop: FunctionComponent = () => {
    const dispatch = useRootDispatch()
    const direction = useRootSelector(state => state.global.user.data.settings.tasks_direction ?? 'by_priority')


    //const directions = useRootSelector(state=>state.pages.taskFilters.direction)
    //const departments = useRootSelector(state=>state.pages.taskFilters.department)
    //const users = useRootSelector(state=>state.pages.taskFilters.user)
    //const clients = useRootSelector(state => state.pages.taskFilters.client)
    //const brands = useRootSelector(state => state.pages.taskFilters.brand)
    //const workObject = useRootSelector(state => state.pages.taskFilters.work_object)
    //const tasksTypes = useRootSelector(state => state.pages.taskFilters.tasks_type)

    const directions = useRootSelector(state => {
        if (window.localStorage.getItem('TF_direction')) {
            const x: any = window.localStorage.getItem('TF_direction') ? window.localStorage.getItem('TF_direction') : '' // eslint-disable-line
            return JSON.parse(x)
        } else {
            return state.pages.taskFilters.direction
        }
    })

    const departments = useRootSelector(state => {
        if (window.localStorage.getItem('TF_department')) {
            const x: any = window.localStorage.getItem('TF_department') ? window.localStorage.getItem('TF_department') : '' // eslint-disable-line
            return JSON.parse(x)
        } else {
            return state.pages.taskFilters.department
        }
    })

    const users = useRootSelector(state => {
        if (window.localStorage.getItem('TF_user')) {
            const x: any = window.localStorage.getItem('TF_user') ? window.localStorage.getItem('TF_user') : '' // eslint-disable-line
            return JSON.parse(x)
        } else {
            return state.pages.taskFilters.user
        }
    })

    const clients = useRootSelector(state => {
        if (window.localStorage.getItem('TF_client')) {
            const x: any = window.localStorage.getItem('TF_client') ? window.localStorage.getItem('TF_client') : '' // eslint-disable-line
            return JSON.parse(x)
        } else {
            return state.pages.taskFilters.client
        }
    })

    const brands = useRootSelector(state => {
        if (window.localStorage.getItem('TF_brand')) {
            const x: any = window.localStorage.getItem('TF_brand') ? window.localStorage.getItem('TF_brand') : '' // eslint-disable-line
            return JSON.parse(x)
        } else {
            return state.pages.taskFilters.brand
        }
    })
    const workObject = useRootSelector(state => {
        if (window.localStorage.getItem('TF_work_object')) {
            const x: any = window.localStorage.getItem('TF_work_object') ? window.localStorage.getItem('TF_work_object') : '' // eslint-disable-line
            return JSON.parse(x)
        } else {
            return state.pages.taskFilters.work_object
        }
    })


    const tasksTypes = useRootSelector(state => {
        if (window.localStorage.getItem('TF_tasks_type')) {
            const x: any = window.localStorage.getItem('TF_tasks_type') ? window.localStorage.getItem('TF_tasks_type') : '' // eslint-disable-line
            return JSON.parse(x)
        } else {
            return state.pages.taskFilters.tasks_type
        }
    })

    return <div className={styles.desktop}>

        {/*<ThreeLevelDropdown<DirectionWithDepartments, Departments, User>
            className={clsx(styles.dropdown,styles.mxw300)}
            placeholder={'Направление/Отдел/Сотрудник'}
            selection={directions}
            subselection={departments}
            subsubselection={users}
            render={direction => direction.title}
            subRender={department => department.title}
            subsubRender={user => user.name}
            selector={direction => direction.departments}
            subselector={department => department.users}
            request={query => apiRequests.dictionary.directionList({
                query: {search_full: query.search}
            })}
            onSelectionChange={flow(taskFiltersActions.setDirections, dispatch, addDirectionLS)}
            onSubselectionChange={flow(taskFiltersActions.setDepartments, dispatch, addDepartmentLS)}
            onSubsubselectionChange={flow(taskFiltersActions.setUsers, dispatch, addUserLS)}
        />*/}
        <div className={styles.filterBlock}>
            <div className={styles.filterTitle}>Направление</div>
            <RequestDropdown<DirectionWithDepartments>
                className={clsx(styles.dropdown, styles.mxw150)}
                render={direction => direction.title}
                type={'multi'}
                placeholder={'Направление'}
                request={query => apiRequests.dictionary.directionList({
                    query: {search_full: query.search}
                })}
                value={directions ? directions : []}
                onChange={flow(taskFiltersActions.setDirections, dispatch, addDirectionLS)}
            />
        </div>
        <div className={styles.filterBlock}>
            <div className={styles.filterTitle}>Отдел</div>
            <RequestDropdown<Departments>
                className={clsx(styles.dropdown, styles.mxw200)}
                render={department => department.title}
                type={'multi'}
                placeholder={'Отдел'}
                request={query => apiRequests.dictionary.departmentList({
                    query: query
                })}
                value={departments ? departments : []}
                onChange={flow(taskFiltersActions.setDepartments, dispatch, addDepartmentLS)}
            />
        </div>
        <div className={styles.filterBlock}>
            <div className={styles.filterTitle}>Сотрудник</div>
            <RequestDropdown<User>
                className={clsx(styles.dropdown, styles.mxw150)}
                render={user => user.name}
                type={'multi'}
                placeholder={'Сотрудник'}
                request={query => apiRequests.users.list({
                    query: query
                })}
                value={users ? users : []}
                onChange={flow(taskFiltersActions.setUsers, dispatch, addUserLS)}
            />
        </div>
        <div className={clsx(styles.mt15, styles.separator)}></div>
        <div className={styles.filterBlock}>
            <div className={styles.filterTitle}>Клиент/Бренд</div>
            <TwoLevelDropdown<ClientWithBrands, Brand>
                className={clsx(styles.dropdown, styles.mxw200)}
                placeholder={'Клиент/Бренд'}
                selection={clients}
                subselection={brands}
                render={client => client.short_title}
                subRender={brand => brand.title}
                selector={client => client.brands}
                request={query => apiRequests.dictionary.list({
                    query,
                    params: {key: 'client'}
                })}
                onSelectionChange={flow(taskFiltersActions.setClients, dispatch, addClientLS)}
                onSubselectionChange={flow(taskFiltersActions.setBrands, dispatch, addBrandLS)}
            />
        </div>
        <div className={clsx(styles.mt15, styles.separator)}></div>
        <div className={styles.filterBlock}>
            <div className={styles.filterTitle}>Тип объекта</div>
            <RequestDropdown<WorkObject>
                className={clsx(styles.dropdown, styles.mxw150)}
                render={workObject => workObject.name}
                type={'multi'}
                placeholder={'Тип объекта'}
                request={query => apiRequests.project.tipWorkObject({
                    query: query
                })}
                value={workObject ? workObject : []}
                onChange={flow(taskFiltersActions.setWorkObjects, dispatch, addWorkObjectLS)}
            />
        </div>
        <div className={styles.filterBlock}>
            <div className={styles.filterTitle}>Тип задачи</div>
            <RequestDropdown<TaskType>
                className={clsx(styles.dropdown, styles.mxw150)}
                render={task => task.name}
                type={'multi'}
                placeholder={'Тип задачи'}
                request={query => apiRequests.project.tipTaskType({
                    query: query
                })}
                value={tasksTypes ? tasksTypes : []}
                //onChange={ flow(taskFiltersActions.setTasksType, dispatch)}
                onChange={flow(taskFiltersActions.setTasksType, dispatch, addTasksTypeLS)}
            />
        </div>
        <Button
            className={styles.mt15}
            title={'Очистить фильтры'}
            onClick={() => {
                dispatch(taskFiltersActions.clearFilters())
                clearFilterLS()
            }}
        >
            <FiltersClearIcon/>
        </Button>
        <Spacer/>
        <SwitchSort
            data={['by_number', 'by_priority']}
            value={direction === 'by_number' ? 'by_number' : 'by_priority'}
            onChange={() => {
                if (direction === 'by_number') {
                    dispatch(userActions.update.request({
                        settings: {
                            tasks_direction: 'by_priority'
                        }
                    }))
                } else {
                    dispatch(userActions.update.request({
                        settings: {
                            tasks_direction: 'by_number'
                        }
                    }))
                }
            }
            }
            text1={'Номер'}
            text2={'Приоритет'}
            title={'Сортировка:'}
        />

    </div>
}

export default TaskFiltersDesktop
